export const brandingConstants = {
  SUCCESS: 'BRANDING_SUCCESS',
  ERROR: 'BRANDING_ERROR',
  CLEAR: 'BRANDING_CLEAR',
  CURRENTCOMPONENT: 'BRANDING_COMPONENT',
};
